
    import { Vue, Component } from 'vue-property-decorator'
    import Layout from '../../common/components/layout/layout.vue'
    import { mapState } from 'vuex'
    import { Consumer } from '@/app/identity'

    @Component({
        components: { Layout },
        computed: {
            ...mapState('auth', ['consumer'])
        }
    })
    export default class Settings extends Vue {
        consumer!: Consumer
    }
